import type { MailContentProps, MailMetadata } from "../../lib/types";
import { MailSignature } from "../mail/mail-signature";

function DemandeFormationLicenceProfessionnelle({
  variablesData,
}: MailContentProps) {
  return (
    <div className="space-y-2">
      <p className="pb-4">
        Bonjour {variablesData.genre_masc_complet}{" "}
        {variablesData.responsable_grand_est_precedent_nom},
      </p>
      <p>
        Lors de mon entretien annuel d'appréciation j'ai fait part à{" "}
        {variablesData.genre_masc_complet}{" "}
        {variablesData.responsable_administration_nom} de ma volonté de
        progresser dans les missions qui me sont confiées au sein de
        l'entreprise et de m'engager dans une formation en cours du soir qui me
        permettrait d'obtenir une licence en Ressources Humaines.{" "}
      </p>
      <p>
        Je me permets de prendre contact directement avec vous car{" "}
        {variablesData.genre_masc_complet}{" "}
        {variablesData.responsable_administration_nom}, que j'ai relancé
        plusieurs fois, m'a dit que ma demande, bien que légitime, n'était pas «
        à l'ordre du jour ». Or cette formation s'intégrerait{" "}
        <span>
          au projet de mise en œuvre d'une fonction Ressources Humaines que vous
          souhaitez développer ainsi que vous l'avez exprimé lors du dernier
          Comité d'Entreprise.{" "}
        </span>
        Je partage votre position car l'intitulé de la fonction administrative
        est aujourd'hui dépassée.
      </p>
      <p>
        Il me semble cependant que compte tenu du contexte actuel une meilleure
        prise en compte de la gestion de nos ressources humaines serait de
        nature à améliorer le climat social et donc les performances du
        Personnel. Par ailleurs, je dois confirmer dans les 15 jours la
        possibilité de m'inscrire à ce diplôme.
      </p>
      <p>
        Je vous remercie de l'attention que vous porterez à ce courriel et je
        vous prie de croire, Monsieur le Responsable, en l'assurance de ma
        parfaite considération,{" "}
      </p>
      <MailSignature
        emetteurLogo={
          DemandeFormationLicenceProfessionnelle.metadata.emetteurLogo
        }
        emetteur={DemandeFormationLicenceProfessionnelle.metadata.emetteur}
        emetteurPoste={
          DemandeFormationLicenceProfessionnelle.metadata.emetteurPoste
        }
        emetteurEntreprise={
          DemandeFormationLicenceProfessionnelle.metadata.emetteurEntreprise
        }
      />
    </div>
  );
}

DemandeFormationLicenceProfessionnelle.metadata = {
  titre: "Demande de Formation – Licence professionnelle RH",
  cleMail: "demande_formation_licence_professionnelle_rh",
  messageTransfert: false,
  emetteur: "Gilles DELACOURT",
  emetteurPoste:
    "Responsable du Personnel et de l'Accueil – Service du Personnel",
  emetteurEntreprise: "SYTEL Grand Est",
  emetteurLogo: null,
  dateRelative: -7,
  piecesJointes: ["licence-pro-grh-cnam"],
} as MailMetadata;

export default DemandeFormationLicenceProfessionnelle;
